import { Dimensions } from 'react-native';

export function useWindowResize() {
  return Dimensions.get('window');
}
